import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MessageCircle } from "lucide-react";
import type { TranslateFn } from "@/types";

interface ContactMethodFieldsProps {
  lineId: string;
  whatsappNumber: string;
  onChange: (field: string, value: string) => void;
  t: TranslateFn;
}

export const ContactMethodFields = ({ lineId, whatsappNumber, onChange, t }: ContactMethodFieldsProps) => (
  <div className="space-y-4">
    <h3 className="font-semibold text-lg flex items-center gap-2">
      <MessageCircle className="h-5 w-5" />
      {t('booking.contactMethod')} *
    </h3>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <Label htmlFor="line_id">{t('booking.lineId')}</Label>
        <Input
          id="line_id"
          data-testid="input-line-id"
          value={lineId}
          onChange={(e) => onChange("line_id", e.target.value)}
          placeholder={t('booking.lineIdPlaceholder')}
        />
        <p className="text-xs text-muted-foreground mt-1">
          {t('booking.lineIdHelp')}
        </p>
      </div>
      <div>
        <Label htmlFor="whatsapp_number">{t('booking.whatsapp')}</Label>
        <Input
          id="whatsapp_number"
          data-testid="input-whatsapp-number"
          value={whatsappNumber}
          onChange={(e) => onChange("whatsapp_number", e.target.value)}
          placeholder={t('booking.whatsappPlaceholder')}
        />
        <p className="text-xs text-muted-foreground mt-1">
          {t('booking.whatsappHelp')}
        </p>
      </div>
    </div>
    <p className="text-sm text-muted-foreground">* {t('booking.contactRequired')}</p>
  </div>
);
